<template>
    <div class="promo-about-section" v-if="indexPage != null">
        <div class="container">
            <div class="column-container">
                <div class="col-right">
                    <div class="about-video" :style="'background-image:url(' + indexPage.about_img_prev + ')'">
                        <div class="video-link" @click="initVideo = true" v-if="!initVideo">
                            <div class="icon-play-container">
                                <svgIcon name="play" class="icon-play"/>
                            </div>
                        </div>
                        <div class="video-player" v-if="initVideo">
                            <iframe :src="indexPage.about_video_link + '?autoplay=1&loop=1&rel=0&showinfo=0&vq=highres&color=white&iv_load_policy=3'" frameborder="0" allow="autoplay" allowfullscreen></iframe>
                        </div>
                       
                        <!-- <div class="video-item-img">
                            <img :src="indexPage.about_img_prev" alt="">
                        </div> -->
                    </div>
                </div>
                <div class="col-left">
                    <h3>{{ indexPage.about_title }}</h3>
                    <div class="col-desc" v-html="indexPage.about_desc"></div>
                    <router-link to="/about" class="link-to-page">
                        <span>{{indexPage.about_more_btn}}</span>
                        <svgIcon name="arrow-go-right"/>
                    </router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'sales-about-promo',
        components: {
            svgIcon,
        },
        data () {
            return {
                initVideo: false,
            }
        },
        computed: mapGetters({
            indexPage: 'loadIndexPage',
        }),
        methods: {
            startLoader() {
                this.$parent.$parent.$refs.topProgress.start();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/index-promo/promo-about.scss';
    @import '@/styles/respond/index-promo/respond-promo-about.scss';
    // @import '@/styles/respond/index-promo/respond-promo-fine-finish.scss';
</style>